import { EntityConfiguration } from '../..'

export class TableUtils {
  public static getEntityDialogContext(
    configuration: EntityConfiguration,
    mode: 'create' | 'update' | 'action',
    buttonTxt?: string,
    headerTxt?: string,
    desc?: string
  ): any {
    let dialogContext = {}

    // get context from config, otherwise take general context.
    switch (mode) {
      case 'create': {
        dialogContext['buttonTxt'] = configuration.createButtonText ? configuration.createButtonText : 'Speichern'
        dialogContext['headerTxt'] = configuration.createDialogHeaderText
          ? configuration.createDialogHeaderText
          : `${configuration.singleDisplayName} anlegen`
        dialogContext['desc'] = configuration.createDescription ? configuration.createDescription : undefined
        break
      }
      case 'update': {
        dialogContext['buttonTxt'] = configuration.updateButtonText ? configuration.updateButtonText : 'Aktualisieren'
        dialogContext['headerTxt'] = configuration.updateDialogHeaderText
          ? configuration.updateDialogHeaderText
          : `${configuration.singleDisplayName} bearbeiten`
        dialogContext['desc'] = configuration.updateDescription ? configuration.updateDescription : undefined
        break
      }
      case 'action': {
        dialogContext['buttonTxt'] = buttonTxt ? buttonTxt : 'Ausführen'
        dialogContext['headerTxt'] = headerTxt ? headerTxt : 'Parameter eingeben'
        dialogContext['desc'] = desc ? desc : undefined
        break
      }
    }
    return dialogContext
  }

  public static getDefaultColumnWidth(type: string) {
    switch (type) {
      case 'int':
        return 100
      case 'String':
      case 'Address':
      case 'Multiline':
        return 200
      case 'boolean':
      case 'Icon':
        return 100
      case 'Date':
        return 150
      default:
        return 150
    }
  }
}
